import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import NewIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PropTypes from 'prop-types';
import classes from './actionsButton.module.scss';

export default function ActionsButton(props) {
  const { activityName, clickHandler, disabled = false, isReverted = false, withSizeCorrection = false } = props;
  const { t } = useTranslation();
  const settings = {
    createAlert: {
      label: t('common.general.createAlert'),
      component: <NewIcon />
    },
    save: {
      label: t('common.general.save'),
      component: <CheckIcon />
    },
    cancel: {
      label: t('common.general.cancel'),
      component: <CloseIcon />
    },
    delete: {
      label: t('common.general.delete'),
      component: <DeleteOutlineOutlinedIcon />
    },
    edit: {
      label: t('common.general.edit'),
      component: <ModeEditOutlineOutlinedIcon />
    }
  };

  return (
    <div
      data-testid="actionbutton"
      className={`${classes.container} ${disabled ? classes.disabled : ''} ${isReverted ? classes.reverted : ''} ${
        withSizeCorrection ? classes.withSizeCorrection : ''
      }`}
      role="presentation"
      onClick={() => {
        if (!disabled) clickHandler();
      }}
    >
      <span className={classes.actionLabel}>{settings[activityName].label}</span>
      {settings[activityName].component}
    </div>
  );
}

ActionsButton.propTypes = {
  activityName: PropTypes.oneOf(['createAlert', 'save', 'cancel', 'delete', 'edit']),
  clickHandler: PropTypes.func,
  disabled: PropTypes.bool,
  isReverted: PropTypes.bool,
  withSizeCorrection: PropTypes.bool
};
